
import React, { useRef, useState } from 'react';
import { Box, Card, CardContent, CardHeader,Typography } from "@mui/material"
import * as am5 from "@amcharts/amcharts5"
import * as am5percent from "@amcharts/amcharts5/percent"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import { useLayoutEffect } from "react"

const conversacionesPorLineaData = [
    { linea: "Línea A", valor: 40 },
    { linea: "Línea B", valor: 30 },
    { linea: "Línea C", valor: 20 },
    { linea: "Línea D", valor: 10 },
]

const colors = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"];

const ConversacionPorLinea = (ConversationData) => {
    const chartRef = useRef(null);
    const [totalConversaciones, setTotalConversaciones] = useState(0);



    useLayoutEffect(() => {
        if (!chartRef.current) return

        // Crear instancia del gráfico
        const root = am5.Root.new(chartRef.current)
        root.setThemes([am5themes_Animated.new(root)])

        // Crear gráfico de pastel
        const chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                layout: root.verticalLayout,  
                innerRadius: am5.percent(40),
            }),
        )

        // Crear la serie   
        var series = chart.series.push(
            am5percent.PieSeries.new(root, {
                valueField: "valor",
                categoryField: "linea",
                alignLabels: false,
            }),
        )

        series.set("colors", am5.ColorSet.new(root, { 
            colors:
            [am5.color("#FF6384"), am5.color("#36A2EB"), am5.color("#FFCE56"), am5.color("#4BC0C0")]
        
        }))

        series.labels.template.setAll({
            text: "", // Ocultar texto en el gráfico
            textType: "circular",
            radius: 4,
        })

        series.slices.template.set("tooltipText", "{category}: {valuePercentTotal.formatNumber('#.0')}%");

        series.data.setAll(ConversationData.ConversationData)
        series.appear(1000, 100)

        setTotalConversaciones(ConversationData.ConversationData.reduce((acc, item) => acc + item.valor, 0))
        
        return () => {
            root.dispose()
        }
    }, [ConversationData])


    const calcularPorcentaje = (valor) => {
        if(totalConversaciones === 0) return 0;
        return ((valor * 100) / totalConversaciones).toFixed(2);
    }

    return (
        <Card>
            <CardHeader title="Conversaciones por Línea" />
            <CardContent>
                <Box ref={chartRef} style={{ width: "100%", height: 200 }} />
                <Box
                    display="grid"
                    gridTemplateColumns="repeat(2, 1fr)"
                    gap={2}
                    p={2}
                    sx={{ border: 1, borderColor: 'divider' }}
                >
                    {ConversationData.ConversationData.map((item, index) => (
                        <Box key={index} display="flex" alignItems="center" sx={{ gap: 1 }}>
                            <Box sx={{ width: 12, height: 12, backgroundColor: colors[index] }} />
                            <Typography variant="caption" color="textSecondary">
                                {item.linea}: {calcularPorcentaje(item.valor)}%
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    )
}

export default ConversacionPorLinea;